var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Crear Proforma"}},[_c('div',[_c('vs-button',{on:{"click":_vm.saveProforma}},[_vm._v("Guardar")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }